import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { cooperplaceApi } from 'services/api';
import { useSnackbar } from 'v3/components/Snackbar';
import ApplicationLayout from 'v3/layouts/Application';
import { BadgeActive, Button, DataTable, Fallback, Modal, Text } from 'v3/components';
import { DefaultLoadingComponent } from 'v3/components/List';
import { validatePermission } from 'actions';
import { Filter } from './Filter';
import { Link } from 'react-router-dom';
import { useModal } from 'hooks';
import { StyledFilesCol } from 'v3/pages/Travel/Register/Modals/UpdateDriver/styles';
import { Attachment } from 'v3/components/Attachment';
import { Tooltip } from 'v3/components';
import { BsFillQuestionCircleFill } from 'react-icons/bs';
import { formatDateTime } from 'v3/utils/formatter';
import TextArea from 'v3/components/TextArea';

export function SystemLogsList() {
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const hasPermissionToView = validatePermission('VISUALIZAR_LOGS');
  const hasPermissionToValidate = validatePermission('VALIDAR_MOTORISTA');
  const [systemLogsData, setSystemLogsData] = useState([]);
  const [systemLogsFilter, setSystemLogsFilter] = useState([]);
  const [logSelected, setLogSelected] = useState({});
  const [loading, setLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);

  const [filter, setFilter] = useState({
    id: '' ,
    name: '',
    cpf: '',
    email: '',
    phone: '',
    status: ''
  });

  const [showModalDocuments, setShowModalDocuments] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [reasonDescription, setReasonDescription] = useState('');
  const [selectedDocument, setSelectedDocument] = useState([]);
  const modalDocuments = useModal();

  useEffect(() => {
    if (showModalDocuments) {
      const styleId = 'modal-documentos-zindex-fix';
      const existingStyle = document.getElementById(styleId);

      if (!existingStyle) {
        const style = document.createElement('style');
        style.id = styleId;
        style.innerHTML = `
          div.modal.modal-documentos-motorista,
          div.modal.modal-documentos-motorista.show {
            z-index: 10004 !important;
          }
          div.modal-backdrop.show {
            z-index: 10003 !important;
          }
          .ril-outer.ril__outer.ril__outerAnimating,
          .ril-outer {
            z-index: 10005 !important;
          }
          .ril__outer {
            z-index: 10005 !important;
          }
          .ReactModalPortal > div {
            z-index: 10005 !important;
          }
          div.modal.modal-documentos-pdf,
          div.modal.modal-documentos-pdf.show {
            z-index: 10006 !important;
          }
        `;
        document.head.appendChild(style);
      }
    }

    return () => {
      const styleId = 'modal-documentos-zindex-fix';
      const existingStyle = document.getElementById(styleId);
      if (existingStyle) {
        existingStyle.remove();
      }
    };
  }, [showModalDocuments]);

  async function filterData(logData, logFilter) {
    const logDataFiltered = logData.filter(item => {
      let locateId = true;
      const id = logFilter.id.replace(/[^0-9]/g, '').toString();
      if (item.user.id && id !== '') {
        locateId = item.user.id.toString().indexOf(id) !== -1;
      } else if (!item.user.id && id !== '') {
        locateId = false;
      }

      let locateName = true;
      const name = logFilter.name.toUpperCase();
      if (item.user.username && logFilter.name !== '') {
        locateName = item.user.username.toUpperCase().indexOf(name) !== -1;
      } else if (!item.user.username && name !== '') {
        locateName = false;
      }

      let locateCpf = true;
      const cpf = logFilter.cpf.replace(/[^0-9]/g, '').toString();
      if (item.user.cpf && cpf !== '') {
        const userCpf = item.user.cpf.replace(/[^0-9]/g, '').toString();
        locateCpf = userCpf.indexOf(cpf) !== -1;
      } else if (!item.user.cpf && cpf !== '') {
        locateCpf = false;
      }

      let locateEmail = true;
      const email = logFilter.email.toLowerCase();
      if (item.user.email && logFilter.email !== '') {
        locateEmail = item.user.email.toLowerCase().indexOf(email) !== -1;
      } else if (!item.user.email && email !== '') {
        locateEmail = false;
      }

      let locatePhone = true;
      const phone = logFilter.phone.replace(/[^0-9]/g, '').toString();
      if (item.user.phoneNumberUnmasked && phone !== '') {
        locatePhone = item.user.phoneNumberUnmasked.toString().indexOf(phone) !== -1;
      } else if (!item.user.phoneNumberUnmasked && phone !== '') {
        locatePhone = false;
      }

      let locateStatus = true;
      const status = logFilter.status.name;
      if (status !== '' && status === 'Sucesso') {
        locateStatus = item?.success;
      } else if (status !== '' && status === 'Erro') {
        locateStatus = !item?.success;
      } else if (status !== '' && (status === 'Sucesso' || status === 'Erro')) {
        locateStatus = false;
      }

      setLoading(false);
      return locateId && locateName && locateCpf && locateEmail && locatePhone && locateStatus;
    });

    setSystemLogsFilter(logDataFiltered);
  }

  async function fetchData() {
    try {
      setLoading(true);
      const { data } = await cooperplaceApi.get('systemlogs', {});
      setSystemLogsData(data);
      filterData(data, filter);
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        'Não foi possível recuperar os registros';
      snackbar.show(<Text>{message}</Text>, {
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  }

  function onModalDocumentsClose() {
    setShowModalDocuments(false);
    modalDocuments.close();
    setSelectedDocument([]);
    setReasonDescription('')
    setIsValidating(false)
    setLogSelected({})
  }

  async function validateDriver() {
    if(reasonDescription?.length >= 30){
      try {
        setLoading(true);
        await cooperplaceApi.post(`/drivers/accept-person-verification/${logSelected?.user?.person?.driver?.id}`, {
          reason: reasonDescription,
          documentMediaId: logSelected?.input?.driverLicense?.id,
          selfieMediaId: logSelected?.input?.selfie?.id,
          systemLogId: logSelected?.id
        });
        snackbar.show(
          <Text>Motorista validado com sucesso</Text>,
          {
            type: 'success',
          }
        );
        await fetchData()
        onModalDocumentsClose()
      } catch (error) {
        const message =
          error?.message ||
          'Não foi possível validar o motorista';
        snackbar.show(<Text>{message}</Text>, {
          type: 'error',
        });
        onModalDocumentsClose()
      } finally {
        setLoading(false);
      }
    } else{
      snackbar.show(<Text>Observação tem que ter mais de 30 caracteres</Text>, {
        type: 'error',
      });
    }
  }

  async function fetchSystemLogStatus() {
      const data = [
        {
          id:0,
          name:'Todos'
        },
        {
          id:1,
          name:'Sucesso'
        },
        {
          id:2,
          name:'Erro'
        }
      ]
      setStatusOptions(data);
  }

  function onFilterChange(params) {
    setFilter(params);
    filterData(systemLogsData, params);
  }

  useEffect(() => {
    if (hasPermissionToView) {
      fetchSystemLogStatus();
      fetchData();
    }
    onModalDocumentsClose()
  }, []);

  useEffect(() => {
    if (!hasPermissionToView) {
      snackbar.show(
        <Text>Você não tem permissão para visualizar os registros</Text>,
        { type: 'error' }
      );
      navigate('/');
    }
  }, [hasPermissionToView]);

  function onModalDocumentsOpen(item) {
    let itemParse = item;
    setLogSelected(item)
    setSelectedDocument(itemParse);
    setShowModalDocuments(true);
    modalDocuments.open();

  }

  return (
    <ApplicationLayout title="Logs do Sistema" contentFluid >
      <Modal
        show={showModalDocuments}
        handleClose={() => onModalDocumentsClose()}
        heading={ isValidating ? "Validar Motorista Manualmente"  : "Documentos do Motorista"}
        className="modal-documentos-motorista"
        body={
          isValidating
          ?
            <>
              <Text>
                {`Motorista: ${selectedDocument?.user?.username}`}
              </Text>
              <TextArea
                resizable={false}
                label='Observação miníma de 30 caracteres'
                value={reasonDescription}
                onChange={e => setReasonDescription(e.target.value)}
                disabled={loading}
              />
            </>
          :
          <Row>
              <Row>
                <StyledFilesCol>
                  <Text type="label" color="dark" weight={500}>
                    Documentos do Motorista {selectedDocument?.user?.username}
                  </Text>
                  <div>
                    {selectedDocument?.input?.driverLicense?.data?.full_path && (
                      selectedDocument?.input?.driverLicense?.data?.name.indexOf('pdf') > 0 ? (
                        <Attachment
                        deleteOption={false}
                        attachment={{
                          id: selectedDocument?.input?.driverLicense?.data?.id,
                          full_path: selectedDocument?.input?.driverLicense?.data?.full_path,
                          due_date: selectedDocument?.input?.driverLicense?.data?.createdAt,
                        }}
                        attachments={[selectedDocument?.input?.driverLicense?.data]}
                        loading={false}
                        modalClassName="modal-documentos-pdf"
                        />
                      ) : <Attachment
                        deleteOption={false}
                        attachment={{
                          id: selectedDocument?.input?.driverLicense?.data?.id,
                          full_path: selectedDocument?.input?.driverLicense?.data?.full_path,
                          due_date: selectedDocument?.input?.driverLicense?.data?.createdAt,
                        }}
                        attachments={[selectedDocument?.input?.driverLicense?.data]}
                        loading={false}
                        modalClassName="modal-documentos-pdf"
                        />
                    )}
                    {selectedDocument?.input?.selfie?.data?.full_path && (
                      <Attachment
                      deleteOption={false}
                      attachment={{
                        id: selectedDocument?.input?.selfie?.data?.id,
                        full_path: selectedDocument?.input?.selfie?.data?.full_path,
                        due_date: selectedDocument?.input?.selfie?.data?.createdAt,
                      }}
                      attachments={[selectedDocument?.input?.selfie?.data]}
                      loading={false}
                      modalClassName="modal-documentos-pdf"
                      />
                    )}
                  </div>

                  {
                  logSelected?.manualValidationLogs?.length > 0 &&
                    <>
                      <div>
                        <Text fontSize={14}  weight={700}>
                          Validado por:
                        </Text>
                        <Text fontSize={14}>
                          {`${logSelected?.manualValidationLogs[0]?.validatedUser?.username}`}
                        </Text>
                      </div>
                      <div>
                        <Text fontSize={14}  weight={700}>
                          Observação:
                        </Text>
                        <Text fontSize={14} >
                          {`${logSelected?.manualValidationLogs[0]?.obs}`}
                        </Text>
                      </div>
                    </>
                  }
                </StyledFilesCol>
              </Row>
            </Row>
        }
        footer={
          isValidating
          ?
          <Row style={{ justifyContent: 'flex-end' }}>
             { hasPermissionToValidate && logSelected?.user?.person?.driver && !logSelected?.user?.person?.driver?.verified_person && <Col style={{ width: 300, display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                onClick={() => validateDriver()}
                loading={loading}
                variant="success"
              >
                <Text color="white">
                  Validar
                </Text>
              </Button>
            </Col>}
            <Col style={{ width: 200}}>
              <Button
                variant="primary"
                onClick={() => setIsValidating(false)}
                loading={loading}

              >
                <Text color="white">
                  Cancelar
                </Text>
              </Button>
            </Col>
          </Row>
          :
          <>
            <Row style={{ justifyContent: 'flex-end' }}>
              { hasPermissionToValidate && logSelected?.user?.person?.driver && !logSelected?.user?.person?.driver?.verified_person && <Col style={{ width: 300, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  onClick={() => setIsValidating(true)}
                  loading={loading}
                  variant="success"

                >
                  <Text color="white">
                    Validar Motorista
                  </Text>
                </Button>
              </Col>}
              <Col style={{ width: 200}}>
                <Button
                  variant="primary"
                  onClick={() => onModalDocumentsClose()}
                  loading={loading}
                >
                  <Text color="white">
                    Fechar
                  </Text>
                </Button>
              </Col>
            </Row>
          </>
        }
      />
      <Filter
        onRefresh={fetchData}
        onFilterChange={onFilterChange}
        statusOptions={statusOptions}
        loading={loading}
        setLoading={setLoading}
      />
      <Row>
        <Col className="my-5">
          <Fallback
            fall={systemLogsFilter?.length === 0}
            component={
              loading ? (
                <DefaultLoadingComponent />
              ) : (
                <Col xs={12} className="d-flex justify-content-center my-5">
                  <Button disabled>
                    <Text>Nenhum registro encontrado.</Text>
                  </Button>
                </Col>
              )
            }
          >
            <DataTable
              data={systemLogsFilter}
              loading={loading}
              withFilterOption={false}
              withPagination={false}
              tableStyles={{
                borderCollapse: 'collapse',
                '> thead > tr > th': {
                  borderBottom: '1px solid #E5E7EB',
                },
                '> tbody > tr': {
                  borderBottom: '1px solid #E5E7EB',
                },
                '> tbody > tr:hover': {
                  background: '#F5F6F8',
                },
                '> tbody > tr:hover > td': {
                  background: '#F5F6F8',
                },
              }}
              columns={[
                {
                  name: 'ID Log',
                  selector: row => row?.id,
                },
                {
                  name: 'Status',
                  selector: row =>{
                    if (row?.success) {
                      return (
                        <BadgeActive pill light type="success" className="mr-2">
                          <Text type="label" weight={500}>
                            SUCESSO
                          </Text>
                        </BadgeActive>
                      )
                    } if (row?.manualValidationLogs?.length > 0) {
                      return (
                        <BadgeActive pill light type="primary" className="mr-2">
                          <Text type="label" weight={500}>
                            VALIDAÇÃO MANUAL
                          </Text>
                        </BadgeActive>
                      )
                    }
                      return (
                        <Tooltip
                          content={
                            <Text type="label">
                              {row?.output?.error?.error?.message ? row?.output?.error?.error?.message : row?.output?.error}
                            </Text>
                          }
                          placement="top"
                        >
                          <BadgeActive pill light type="error" className="mr-2">
                            <Text weight={500} type="label">
                              ERRO <BsFillQuestionCircleFill />
                            </Text>
                          </BadgeActive>
                        </Tooltip>
                      )

                  },
                },
                {
                  name: 'Usuario',
                  selector: row => (
                    <Link to={`/usuarios/${row.user_id}`}>
                      {row?.user?.id}
                    </Link>
                  )
                },
                {
                  name: 'Motorista',
                  selector: row => (
                    <Link to={`/motoristas/${row?.user?.person.id}`}>
                      {row?.user?.username}
                    </Link>
                  )
                },
                {
                  name: 'CPF',
                  selector: row => row?.user?.cpf,
                },
                {
                  name: 'E-mail',
                  selector: row => row?.user?.email,
                },
                {
                  name: 'Telefone',
                  selector: row => row?.user?.phonenumber,
                },
                {
                  name: 'Data',
                  selector: row => formatDateTime(row.createdAt),
                },
                {
                  selector: row => (
                    <Button onClick={() => onModalDocumentsOpen(row)}>
                      Documentos
                    </Button>
                  ),
                },
              ]}
            />
          </Fallback>
        </Col>
      </Row>
    </ApplicationLayout>
  );
}
